import React from 'react'
import { IdentificacaoOperadora } from '../../../../interfaces/entities/ComponenteCadastral/IdentificacaoOperadora'
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

const ComponenteCadastralOperadoraData: React.FC<{ identificacaoOperadora: IdentificacaoOperadora | null }> = ({ identificacaoOperadora }) => {

  const accessibility = useAccessibility();
  const font14Style = accessibility.calculateTextStyle(14)
  
  return (
    <div className="registration-data-card-holder margin-top">
      <div className="registration-data-card-service" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-title">Identificação da operadora</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Nome fantasia da operadora</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.nomeFantasiaDaOperadora}</span>
        </div>
        <div className="registration-data-row ">
          <span style={font14Style} className="registration-data-key">Registro da operadora na ANS</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.registroOperadoraANS}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Nome empresarial da adm. de benefícios</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.nomeEmpresarialAdmBeneficio}</span>
        </div>
        <div className="registration-data-row ">
          <span style={font14Style} className="registration-data-key">Nome fantasia da adm. de benefícios</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.nomeFantasiaAdmBeneficio}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Contato da operadora</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.contatoOperadora}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Endereço da operadora</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.enderecoOperaroda}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Contato ANS</span>
          <span style={font14Style} className="registration-data-value">{identificacaoOperadora?.contatoANS}</span>
        </div>
      </div>
    </div>
  )
}

export default ComponenteCadastralOperadoraData